import { callApiToServer } from '../callApi';

export async function addEmployee(
  authtoken,
  employeeObject
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
    
    let body = JSON.stringify(employeeObject);
  
    let endUrl = "v1/auth/create-admin";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
